export default "__VITE_ASSET__cb333b0e__"